import { noCleavageAvailableNotification } from '../entities/notification/notifications';
import { helpMessage } from '../entities/playerMessages';
import { Sound } from '../entities/sound';
import { SupportedSound } from '../entities/SoundType';
export class InterfaceApplicationService {
    constructor(interfaceGateway) {
        this.interfaceGateway = interfaceGateway;
    }
    helpDisabled() {
        return this.interfaceGateway.helpDisabled();
    }
    helpEnabled() {
        return this.interfaceGateway.helpEnabled(helpMessage);
    }
    updateStreamerRegistered(isStreamerRegistered) {
        return this.interfaceGateway.updateStreamerRegistered(isStreamerRegistered);
    }
    updateRegisteredStreamers(streamers) {
        return this.interfaceGateway.updateListOfRegisteredStreamers(streamers);
    }
    updateCleavageDrawpileQuantity(cleavageDrawpileQuantity) {
        return this.interfaceGateway.updateCleavageDrawpileQuantity(cleavageDrawpileQuantity);
    }
    changeVideoExtractVolumeLevel(volume) {
        return Promise.all([
            this.playSound(new Sound(SupportedSound.TICK)),
            this.interfaceGateway.changeVideoExtractVolumeLevel(volume)
        ])
            .then(() => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    changeGamePhase(gamePhase) {
        return this.interfaceGateway.changeGamePhase(gamePhase);
    }
    removeEntityInterfaceState(id) {
        return this.interfaceGateway.removeEntityInterfaceState(id);
    }
    updateEntityInterfaceState(id, interfaceEntityState) {
        return this.interfaceGateway.updateEntityInterfaceState(id, interfaceEntityState);
    }
    disableAutoplay() {
        return this.interfaceGateway.disableAutoplay();
    }
    enableAutoplay() {
        return this.interfaceGateway.enableAutoplay();
    }
    changeMusicVolumeLevel(volume) {
        return this.interfaceGateway.changeMusicVolumeLevel(volume);
    }
    changeSoundVolumeLevel(volume) {
        return this.interfaceGateway.changeSoundVolumeLevel(volume);
    }
    playMusic(music) {
        return this.interfaceGateway.playMusic(music);
    }
    onNoCleavageAvailable() {
        return Promise.all([
            this.clearCleavage(),
            this.notify(noCleavageAvailableNotification)
        ])
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    playSound(sound) {
        return this.interfaceGateway.playSound(sound);
    }
    retrieveCurrentView() {
        return this.interfaceGateway.retrieveCurrentView();
    }
    notify(notification) {
        return this.interfaceGateway.notify(notification);
    }
    updateCleavage(cleavage) {
        return this.interfaceGateway.updateCleavage(cleavage);
    }
    changeView(interfaceView) {
        return this.interfaceGateway.changeView(interfaceView);
    }
    newCleavage() {
        return this.clearCleavage();
    }
    clearCleavage() {
        return this.interfaceGateway.updateCleavage(undefined);
    }
}
